+function ($) {
    'use strict';

    var Calllead = function (element, option) {
        this.$element = $(element);
        this.$rotate = this.$element.find('.calllead__rotator');
        this.$callBtn = this.$element.find('.calllead__phone');

        this._setHidePosition();

        this.rotateDeg = 0;

        this.animateShadow = false;
        this.showed = false;

        var self = this;
        this.$element.bind('mouseover', function () {
            self.rotate();
        });

        this.$element.bind('mouseout', function () {
            self.stopRotate();
        });

        $('html, body').resize(function () {
            self._setHidePosition();
        });

        self.toggleShow();
    };

    Calllead.prototype._setHidePosition = function () {
        var containerTop = $('.container:not(:first)');
        if (containerTop.length > 0) {
            this.scrollerHidePos = containerTop.offset().top;
        } else {
            this.scrollerHidePos = 0;
        }
    };

    Calllead.prototype.toggleShow = function () {
        if (this.showed) {
            this.showed = false;
            this.hide();
        } else {
            this.showed = true;
            this.show();
        }
    };

    Calllead.prototype.show = function () {
        if (!this.animateShadow) {
            this.animateShadow = true;
            var self = this;
            this.$element.animate({
                'opacity': 1,
            }, {
                'dauration': 100,
                'easing': 'swing',
                'complete': function () {
                    self.animateShadow = false;
                }
            });
        }
    };

    Calllead.prototype.hide = function () {
        if (!this.animateShadow) {
            this.animateShadow = true;
            var self = this;
            this.$element.animate({
                'opacity': 0,
            }, {
                'dauration': 100,
                'easing': 'swing',
                'complete': function () {
                    self.animateShadow = false;
                }
            });
        }
    };

    Calllead.prototype.rotate = function () {
        clearInterval(this.idInterval);
        var self = this;
        this.idInterval = setInterval(function () {
            self.rotateDeg++;
            if (self.rotateDeg == 361) {
                self.rotateDeg = 0;
            }
            self.$rotate.css({
                '-moz-transform': 'rotate('+self.rotateDeg+'deg)',
                '-ms-transform': 'rotate('+self.rotateDeg+'deg)',
                '-webkit-transform': 'rotate('+self.rotateDeg+'deg)',
                '-o-transform': 'rotate('+self.rotateDeg+'deg)',
                'transform': 'rotate('+self.rotateDeg+'deg)',
            });
        }, 5);
    };

    Calllead.prototype.stopRotate = function () {
        clearInterval(this.idInterval);
        var self = this;
        this.idInterval = setInterval(function () {
            self.rotateDeg++;
            if (self.rotateDeg == 361) {
                self.rotateDeg = 0;
                clearInterval(self.idInterval);
            }
            self.$rotate.css({
                '-moz-transform': 'rotate('+self.rotateDeg+'deg)',
                '-ms-transform': 'rotate('+self.rotateDeg+'deg)',
                '-webkit-transform': 'rotate('+self.rotateDeg+'deg)',
                '-o-transform': 'rotate('+self.rotateDeg+'deg)',
                'transform': 'rotate('+self.rotateDeg+'deg)',
            });
        }, 5);
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            return new Calllead(this, options)
        });
    };



    var old = $.fn.calllead;

    $.fn.calllead = constructor;
    $.fn.calllead.constructor = constructor;

    $.fn.calllead.noConflict = function () {
        $.fn.calllead = old;
        return this;
    }
}(jQuery);

$(document).ready(function () {
    $('.calllead').calllead();
});